import { SalesforceActions } from 'module/api/integrations/salesforce/types';
import styled from 'styled-components';
import { BlockList } from 'components/organisms/signal/detail/block-list/list';
import { Wrapper } from 'components/organisms/signal/detail/components';
import { AutomationContact } from '../AutomationContact';
import { AutomationChoicesBlock } from '../create/automation-choices';
import { useAutomationContext } from '../create/automation-context';
import { AutomationMatchingConditons } from '../create/automation-matching-conditons';
import { AutomationNameBlock } from '../create/automation-name';
import { AutomationEditProjectBlock } from './blocks/automation-project-edit-block';
import { AutomationThenBlock } from './blocks/then-block';
import { AutomationObjectPickerBlock } from '../create/object-picker';
import { AutomationTriggerConditionBlock } from '../create/trigger-condition';
import { AutomationAccountEditBlock } from './blocks/automation-account-edit-block';

const ContentWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  ${BlockList} {
    padding-bottom: var(--spacing-10);
  }
`;

function EditAutomation() {
  const { automationDetails, isContactSelected } = useAutomationContext();
  const { salesForceType } = automationDetails || {};
  const isProjectSelected = salesForceType === SalesforceActions.Project;
  const isAccountSelected = salesForceType === SalesforceActions.Account;

  return (
    <Wrapper>
      <ContentWrapper>
        <BlockList>
          <AutomationNameBlock />
          <AutomationObjectPickerBlock />
          <AutomationTriggerConditionBlock />
          <AutomationMatchingConditons />
          <AutomationThenBlock>
            <div className="flex flex-col gap-4 heading-01">Then</div>
            <AutomationChoicesBlock />
            {isProjectSelected && <AutomationEditProjectBlock />}
          </AutomationThenBlock>
          {(isProjectSelected || isAccountSelected) && (
            <AutomationThenBlock>
              <div className="flex flex-col gap-4 heading-01">
                Setup Rocketlane Account field mapping
              </div>
              <AutomationAccountEditBlock />
            </AutomationThenBlock>
          )}
          {(isProjectSelected || isAccountSelected) && (
            <AutomationContact checked={isContactSelected} />
          )}
        </BlockList>
      </ContentWrapper>
    </Wrapper>
  );
}

export { EditAutomation };
